<template>
  <div class="chips-container">
    <div class="contactDetail-content">
      <v-text-field
        :placeholder="contentData.responses.namebox.text"
        v-model="nameInput"
        @change="isValidName()"
        outlined
        flat
        block
        label="Name"
        class="input"
      ></v-text-field>
      <v-text-field
        :placeholder="contentData.responses.mailbox.text"
        v-if="!contentData.responses.mailbox.hidden"
        v-model="mailInput"
        @change="isValidMail()"
        outlined
        flat
        block
        label="Email"
        class="input"
      ></v-text-field>
      <p v-show="!isValidMail()">
        {{ contentData.mailValidationMessage }}
      </p>
      <v-text-field
        :placeholder="contentData.responses.telbox.text"
        v-model="telInput"
        @change="isValidTel()"
        outlined
        flat
        block
        label="Telefonnummer"
        class="input"
      ></v-text-field>
      <p v-show="!isValidTel()">
        {{ contentData.telValidationMessage }}
      </p>
    </div>
    <div class="btns-wrap">
      <v-btn :disabled="!userMayProceed()" depressed block class="primary-txt-btn __h68" @click="submitAnswer()">{{
        contentData.responses.submitbutton
      }}</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nameInput: "",
      mailInput: "",
      telInput: "",
      contentData: {
        responses: {
          namebox: {
            text: "placeholder text",
          },
          mailbox: {
            text: "placeholder text",
            hidden: false,
          },
          telbox: {
            text: "placeholder text",
          },
          submitbutton: "submit",
        },
        mailValidationMessage: "",
        telValidationMessage: "",
      },
    }
  },
  methods: {
    submitAnswer() {
      let newInputs = []
      newInputs.push({
        namebox: {
          enteredText: this.$data.nameInput,
          skipped: false,
        },
      })

      // assign mail input (only assign input if textbox is not hidden)
      if (this.contentData.responses.mailbox.hidden === false) {
        if (this.$data.mailInput == "") {
          newInputs.push({
            mailbox: {
              skipped: true,
            },
          })
        } else {
          newInputs.push({
            mailbox: {
              enteredText: this.$data.mailInput,
              skipped: false,
            },
          })
        }
      }

      // assign telephone input
      if (this.$data.telInput == "") {
        newInputs.push({
          telbox: {
            skipped: true,
          },
        })
      } else {
        newInputs.push({
          telbox: {
            enteredText: this.$data.telInput,
            skipped: false,
          },
        })
      }

      console.log(typeof newInputs)
      this.$emit("submitAnswer", newInputs)
    },
    updateContent(executableSystemAction) {
      console.log("Inside updateContent for Contact Detail Card")

      let updatedContent = {
        responses: {
          namebox: executableSystemAction.guiTemplateContent.namebox,
          mailbox: executableSystemAction.guiTemplateContent.mailbox,
          telbox: executableSystemAction.guiTemplateContent.telbox,
          submitbutton: executableSystemAction.guiTemplateContent.submitbutton.text,
        },
      }

      // reset textbox inputs
      this.$data.nameInput = ""
      this.$data.mailInput = ""
      this.$data.telInput = ""

      console.log(updatedContent)

      this.contentData = updatedContent
    },
    // validateInput validates the text input given by the user (used to display an error message and to toggle the submit button)
    // sets the validationMessage and returns true/false whether the user input is valid or not
    isValidMail() {
      if (this.mailInput.length === 0) {
        return false
      }
      let re = new RegExp(
        "^[\\w!#$%&’*+/=?`{|}~^-]+(?:\\.[\\w!#$%&’*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$"
      )
      if (re.test(this.$data.mailInput) === false) {
        // set error message for violated validation rule
        this.contentData.mailValidationMessage = "Bitte geben Sie eine gültige E-Mail Adresse ein!"
        return false
      }

      this.contentData.mailValidationMessage = ""
      return true
    },
    isValidTel() {
      if (this.telInput.length === 0) {
        return false
      }
      let re = new RegExp("^[0-9 +-]+$")
      if (re.test(this.$data.telInput) === false) {
        // set error message for violated validation rule
        this.contentData.telValidationMessage = "Bitte geben Sie eine gültige Telefonnummer ein!"
        return false
      }

      this.contentData.telValidationMessage = ""
      return true
    },
    isValidName() {
      if (this.nameInput.length === 0) {
        return false
      } else {
        return true
      }
    },
    // user may proceed when Name AND (Tel OR Email - unless email is not required=>hidden)
    userMayProceed() {
      return this.isValidName() && (this.isValidMail() || this.isValidTel())
    },
  },
  mounted() {
    // fires an event to indicate Parent Component that DOM is updated and can be safely accessed
    this.$nextTick(() => {
      this.$emit("readyToUpdate")
    })
  },
}
</script>
